import React from 'react';
import { ErrorMessage } from './error-message';
import classNames from 'classnames';
export const TextArea = React.forwardRef(({ error, ...props }, ref) => {
    const css = classNames({
        'form-field__textarea': true,
        'form-control--error': !!error
    });
    return (<>
      <textarea className={css} style={{ minHeight: 'auto' }} ref={ref} {...props}/>
      <ErrorMessage error={error}></ErrorMessage>
    </>);
});
